import { SliceZone } from '@prismicio/react';
import Head from 'next/head';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import smoothscroll from 'smoothscroll-polyfill';

import { CTASlice } from '../CTASlice';
import { FAQSlice } from '../FAQSlice';
import { HeroSlice } from '../HeroSlice';
import { OnboardingSlice } from '../OnboardingSlice';
import { QuestionsSlice } from '../QuestionsSlice';
import { TableSlice } from '../TableSlice';

import { EmploymentFAQLayout } from '@/layouts/EmploymentFAQLayout';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const components = {
  hero_section: HeroSlice,
  compliance_overview_section: OnboardingSlice,
  faqs: FAQSlice,
  why_remote: QuestionsSlice,
  overview_section__centered: CTASlice,
  table_3_columns: TableSlice,
};

export function PreemploymentFAQPage(document) {
  const { body } = document;
  const applyFormRef = useRef();

  return (
    <>
      <DocumentHead document={document} noIndex />
      <Head>
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-remote-sans.css')} />
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-bossa.css')} />
      </Head>
      <SliceZone slices={body} components={components} context={{ applyFormRef }} />
    </>
  );
}
PreemploymentFAQPage.Layout = EmploymentFAQLayout;
